import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'service-order-tracker',
    templateUrl: './service-order-tracker.component.html',
    styleUrls: ['./service-order-tracker.component.scss'],
    standalone: false
})
export class ServiceOrderTrackerComponent implements OnInit {

  @Input() orderDataDetials : any
  constructor() { 

  }

  ngOnInit(): void {
  }

}
